import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * El encabezado de un paso del tab Portfolio: el número, su título y la
 * pregunta que ese paso responde.
 *
 * Los cinco pasos se leen de arriba hacia abajo como una sola historia, de lo
 * macro a lo micro: cuánto es el portafolio, de qué está hecho, a quién le
 * prestás, dónde está y, al final, cada facility para auditar las cifras de
 * arriba.
 *
 * El diseño definitivo del encabezado es LEN-2933; acá vive la estructura, que
 * es lo que LEN-2847 necesita para montar el tab.
 */
@Component({
  selector: 'story-step',
  standalone: true,
  template: `
    <header class="flex flex-col gap-1">
      <h3 class="text-xs font-bold uppercase tracking-wider text-muted">
        {{ n() }} · {{ title() }}
      </h3>
      <p class="text-surface-500">{{ question() }}</p>
    </header>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StoryStep {
  n = input.required<number>();
  title = input.required<string>();
  question = input.required<string>();
}
